<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 3.273c4.952 0 8.963 3.906 8.963 8.727s-4.011 8.727-8.963 8.727c-4.951 0-8.963-3.906-8.963-8.727S6.55 3.273 11.5 3.273zm0 15.765c3.987 0 7.229-3.156 7.229-7.038S15.487 4.962 11.5 4.962c-3.986 0-7.228 3.156-7.228 7.038s3.242 7.038 7.228 7.038zm2.892-7.601c-.64 0-1.157-.503-1.157-1.126 0-.623.517-1.126 1.157-1.126s1.156.503 1.156 1.126c0 .623-.517 1.126-1.156 1.126zm-5.783 0c-.64 0-1.157-.503-1.157-1.126 0-.623.517-1.126 1.157-1.126s1.156.503 1.156 1.126c0 .623-.516 1.126-1.156 1.126zm-.145 2.555a3.988 3.988 0 003.036 1.386 3.976 3.976 0 003.036-1.386.886.886 0 011.222-.11c.368.3.415.831.112 1.19a5.736 5.736 0 01-4.37 1.992 5.736 5.736 0 01-4.37-1.992.828.828 0 01.113-1.19.886.886 0 011.221.11z"/></svg>

</template>


<script>

  export default {"name":"icon-f744fe6b3f5cd46343bc800f51a85fc4"}

</script>